import React, {useEffect} from 'react'
import './index.css';
import Aos from "aos"
import "aos/dist/aos.css"

const Pricing = (props) => {
  useEffect(() => {
    Aos.init({duration:1200});
},[])

  return (
    <>
    <div data-aos="fade-down" className="container">
      <div className="container-fluid">
        <div className="text-center">
          <h2>CHOOSE THE PLAN THAT SUITS YOU</h2>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="panel panel-default text-center">
              <div className="panel-heading">
                <h1>Basic</h1>
              </div>
              <div className="panel-body bg-dark text-light">
                <p><strong> Personal Training</strong></p>
                <p><strong> Weight Training</strong></p>
                <p><strong> BodyBuilding</strong></p>
                <p><strong> Weekly Yoga</strong></p>
                <p><strong> Meal Plan</strong></p>
              </div>
              <div className="panel-footer text-light">
                <h3>&#8377;1200</h3>
                <h4>per month</h4>
                <button type="button" onClick= {() =>{
                  props.history.push('./contact');
                }} className="btn btn-lg">Sign Up</button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="panel panel-default text-center">
              <div className="panel-heading">
                <h1>Pro</h1>
              </div>
              <div className="panel-body bg-dark text-light">
                <p><strong> Personal Training</strong></p>
                <p><strong> Weight Training</strong></p>
                <p><strong> BodyBuilding</strong></p>
                <p><strong> Weekly Yoga</strong></p>
                <p><strong> Meal Plan</strong></p>
              </div>
              <div className="panel-footer text-light">
                <h3>&#8377;3000</h3>
                <h4>for 3 months</h4>
                <button type="button" onClick= {() =>{
                  props.history.push('./contact');
                }} className="btn btn-lg">Sign Up</button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="panel panel-default text-center">
              <div className="panel-heading">
                <h1>Premium</h1>
              </div>
              <div className="panel-body bg-dark text-light">
                <p><strong> Personal Training</strong></p>
                <p><strong> Weight Training</strong></p>
                <p><strong> BodyBuilding</strong></p>
                <p><strong> Weekly Yoga</strong></p>
                <p><strong> Meal Plan</strong></p>
              </div>
              <div className="panel-footer text-light">
                <h3>&#8377;5000</h3>
                <h4>for 6 months</h4>
                <button type="button" onClick= {() =>{
                  props.history.push('./contact');
                }} className="btn btn-lg">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
    <h2 className="text-center">What our customers say</h2>
      <div id="myCarousel" className="carousel slide text-center" data-ride="carousel">
        <ol className="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
        </ol>

        <div className="carousel-inner" role="listbox">
          <div className="item active">
            <h4 className="bold">"This Gym is the best. I am so happy with the result!"<br /><span>Anup Kumar, Vice President, Asansol Disctrict</span></h4>
          </div>
          <div className="item">
            <h4 className="bold">"One word... WOW!!"<br /><span>Rahul Sudrania, Owner, Genexx Club</span></h4>
          </div>
          <div className="item">
            <h4 className="bold">"Could I... BE any more happy with this Gym?"<br /><span>Sangram Chougule, Actor, Mr World, Mr India</span></h4>
          </div>
        </div>

        <a className="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
          <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="right carousel-control" href="#myCarousel" role="button" data-slide="next">
          <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
    </>
  )
}

export default Pricing
